export default "__VITE_ASSET__CkSyvjXR__"